const getFinalClassname = (className: string | undefined, modifier: string): string => {
    const name = className != null ? className : '';
    return name + ' ' + modifier;
};

export default getFinalClassname;
